import * as React from 'react';

interface Props {}

export const PrintSVG: React.SFC<Props> = ({}) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.6" cx="20" cy="20" r="20" fill="#F2DDD5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={`M11.415 25.3398H13.609V28.924H26.391V25.3398H28.5849C29.3635 25.3398 30 24.7033 30 23.9248V17.0372C30 16.2586 29.3635
         15.6222 28.5849 15.6222H26.391V11H13.609V15.6222H11.415C10.6365 15.6222 10 16.2586 10 17.0372V23.9235C10 24.7021 10.6377
          25.3398 11.415 25.3398ZM10.9434 17.0372C10.9434 16.7781 11.1559 16.5655 11.415 16.5655H28.5849C28.8441 16.5655 29.0566 16.7781
           29.0566 17.0372V17.5089C29.0566 17.768 28.8441 17.9806 28.5849 17.9806H11.415C11.1559 17.9806 10.9434 17.768 10.9434 17.5089V17.0372ZM14.5524
            11.9434H25.4476V15.6222H14.5524V11.9434ZM11.415 18.924H28.5849C28.7494 18.924 28.9154 18.9007 29.0566 18.8293V23.8999C29.0566 24.1593 28.8441
             24.3716 28.5849 24.3716H26.391V23.2638H27.0752C27.3344 23.2638 27.5469 23.0512 27.5469 22.7921C27.5469 22.533 27.3344 22.3204 27.0752
              22.3204H12.9248C12.6656 22.3204 12.4531 22.533 12.4531 22.7921C12.4531 23.0512 12.6656 23.2638 12.9248 23.2638H13.609V24.3964H11.415C11.1559
               24.3964 10.9434 24.1839 10.9434 23.9248V18.8542C11.0846 18.9007 11.2506 18.924 11.415 18.924ZM14.5524 27.9806V23.2638H25.4476V27.9806H14.5524Z`}
        fill="black"
        stroke="#F6F6F6"
        strokeWidth="0.2"
      />
    </svg>
  );
};
